import { render, staticRenderFns } from "./PosterDialog.vue?vue&type=template&id=1ef51176&scoped=true&"
import script from "./PosterDialog.vue?vue&type=script&lang=js&"
export * from "./PosterDialog.vue?vue&type=script&lang=js&"
import style0 from "./PosterDialog.vue?vue&type=style&index=0&id=1ef51176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef51176",
  null
  
)

export default component.exports